import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import Autosize from "@marcreichel/alpine-autosize";

import "../../../../JvMTECH.Components/Resources/Private/Main";
import "../Fusion/Prototypes/LazyContent/LazyContent";
import "./JavaScript/RandomColors.js";
import "./JavaScript/CookieStoreShim.js";

if (!window.Alpine) {
    window.Alpine = Alpine;
}
Alpine.plugin(focus);
Alpine.plugin(Autosize);
Alpine.plugin(intersect);
Alpine.start();

if (process.env.NODE_ENV == "development") {
    console.log("JvMTECH.Base Main.js loaded");
}
